import { createI18n } from 'vue-i18n'
import zhCN from '@/locales/manage/zh-CN'
import en from '@/locales/manage/en'
import { appStorage } from '@/utils/storage/app'

const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: appStorage.getLocale(),
  fallbackLocale: 'en',
  messages: {
    'zh-CN': zhCN,
    'en': en
  }
})

export default i18n
